import { Injectable } from '@angular/core';
import { MemoryCacheRepository } from './memory-cache.repository';

@Injectable()
export class LegalCacheRepository extends MemoryCacheRepository<string> {}
